import React from "react";

import { PlayEverywhere } from "./sections/PlayEverywhere";

const Landing: React.FC = () => <PlayEverywhere />;

export default Landing;
